import React, { useEffect, useState } from "react";
import { Container_List } from "../components/Container_List";
import request from "../../Helpers/API";
import Swal from "sweetalert2";

export const ListadoConfiguraciones = () => {
  const [cards, setCards] = useState([]);


  useEffect(() => {
    request
      .get(`MenuUsuarios/AccesosMenus?idmodulo=10`)
      .then((result) => {
        const cards_array = result.map((item) => ({
          titulo: item.titulo,
          ruta: item.ruta,
        }));
        setCards(cards_array);
      })
      .catch((error) => {
        Swal.fire("MENUS COBRANZA", JSON.stringify(error), "error");
      });
  }, []);
  return (
    <Container_List titulo={"LISTADO DE CONFIGURACIONES"} cards={cards} />
  );
};
